import register from '../../../../global/js/registry';
export default register('m-finder-popup-form', () => import(/* webpackMode: "lazy" */ './m-finder-popup-form.controller'));
